import React, { Component } from 'react'
import { Input, Select, Spin, Table, Divider, notification, message, Popconfirm, Tooltip } from 'antd';
import { defaultDateFormat, showErrorInNotification, NetworkDelaySearch, showSuccessInNotification, formatMoney } from '../../lib/util';
import CustomDateRangePicker from '../../components/custom_date_range';
import moment from 'moment';
import FilterFixedInput from '../../components/filter_fixed_input';
import NetworkSelect from '../../lib/ui/network_select';
import { BasicHeader } from '../../components/basic_header';
import { RESTExecutor, withDomains } from '../../lib/domain';
import ErrorWrapper from '../../lib/error_wrapper';
import { COLORS } from '../theme';
import { CustomButton, TransparentButton } from '../../components/basic_items';
import { Link } from 'react-router-dom';
import { DeleteOutline, SpellcheckOutlined, ReplayOutlined, MoreHoriz, CheckOutlined, PriorityHigh, InsertDriveFileOutlined } from '@material-ui/icons';


const queryString = require('query-string');

const packets_cols = ({processing_id,onDeleteUpto,onDelete,onRetry,processing_type,datatype}) => [
    {
        title:"SN #",
        dataIndex:'counter',
        key:'counter',
        render:(value,record,index)=>`${value||""}`
    },
    {
        title: "CREATED AT",
        dataIndex: 'created_at',
        key: 'created_at'
    },
    {
        title: "FILE URI",
        dataIndex: 'file_uri',
        key: 'file_uri'
    },
    {
        title: "MIN TXN DATE",
        dataIndex: 'min_txn_date',
        key: 'min_txn_date'
    },
    {
        title: "MAX TXN DATE",
        dataIndex: 'max_txn_date',
        key: 'max_txn_date'
    },
    {
        title: "TRANSFERRED AT",
        dataIndex: 'transferred_at',
        key:'transferred_at',
        
    },
    {
        title: "TXN COUNT",
        dataIndex: 'txn_count',
        key: 'txn_count',
        className:'right-align',
        render:(txn_count,data)=>{
            let transferred_query={
              dateFrom: data.min_txn_date,
              dateTo: data.max_txn_date,
              parse_batch_id: data.parse_batch_id,
              source:data.source_id,
              fetcher_response_id:data.fetcher_response_id,
              batched:false
            }
            let untransferred_query={
              // dateFrom: data.min_txn_date,
              //   dateTo: data.max_txn_date,
                parse_batch_id: data.parse_batch_id,
                source_id:data.source_id,
                fetcher_response_id:data.fetcher_response_id
            }
            return <div style={{
                display:'flex',
                flexDirection:'column'
            }}>
                <div><Tooltip title={<div style={{
                display:'flex',
                flexDirection:'column',
            }}>
              {data.opening_balance!=null&&<span>Opening Balance: {data.opening_balance}</span>}
              {data.closing_balance!=null&&<span>Closing Balance: {data.closing_balance}</span>}
              {data.txn_net_amount!=null&&<span>Net Amount: {data.txn_net_amount}</span>}
      
            </div>}><Link  to={{
              pathname: `/activity/data-type/${data.data_type_id}${data.transferred ? '/transactions' : '/nottransferredtransactions'}`,
              search: queryString.stringify(data.transferred?transferred_query:untransferred_query)
            }}>{txn_count}</Link></Tooltip>
            </div>
            {data.failed_count!=null&&<Link to={{
                pathname: `/activity/data-type/${data.data_type_id}${data.transferred ? '/transactions' : '/nottransferredtransactions'}`,
                search: queryString.stringify({
                    ...(data.transferred?transferred_query:untransferred_query),
                    failed:'true'
                })

            }}><span className='error-text'>{data.failed_count} Failed</span></Link>}
            </div>
          }
    },
    {
        title: "Status",
        dataIndex: 'error',
        key: 'status',
        className: 'center-align',
        render: (value, record) => {

            let has_error = (!record.processed || record.error);


            return <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
            }}><div className={has_error ? 'text-tag-danger' : 'text-tag-success'}
                style={{
                    width: 22,
                    height: 22,
                    borderRadius: '50%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {record.processed ?
                        record.error ?
                            <MoreHoriz
                                titleAccess="Processed with error"
                                style={{
                                    width: 12
                                }}
                            />
                            :
                            <CheckOutlined
                                titleAccess="Processed without error"
                                style={{
                                    width: 12
                                }} />
                        : <PriorityHigh
                            titleAccess="Not Processed"
                            style={{
                                width: 12
                            }} />}
                </div></div>
        }
    },
    {
        title:"ACTIONS",
        key:'actions',
        width:200,
        className:'center-align',
        render:(data)=>{
            let isDisabled=data.id==processing_id;
            return <div style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center'
            }}>
            {data.transferred?
              <Popconfirm disabled={isDisabled} 
              onConfirm={()=>{
                typeof onDeleteUpto==='function'&&onDeleteUpto(data.id);
              }}
              title="Do you want to untransfer all packets after this?">
              <CustomButton 
              disabled={isDisabled} 
              className='danger-btn no-border'
              style={{
                  fontWeight:'normal'
              }}
              label="Untransfer Upto This"
              />
            </Popconfirm>
            :
            <React.Fragment>
              <Popconfirm disabled={data.transferred||isDisabled||data.processed==false} title="Do you want to transfer this packet?"
            onConfirm={()=>{
              typeof onRetry==='function'&&onRetry(data.id);
            }}
            >
            <CustomButton 
            hint={data.processed==false?"Rerun First":null}
            disabled={data.transferred||isDisabled||data.processed==false} 
            className='primary-btn'
            label="Transfer"
            />
            </Popconfirm>
            {/* <Divider type='vertical' /> */}
            <Popconfirm disabled={data.transferred||isDisabled} title="Do you want to delete this packet?"
            onConfirm={()=>{
              typeof onDelete==='function'&&onDelete(data.id);
            }}
            >
              <CustomButton  
            disabled={data.transferred||isDisabled} 
            className='danger-btn no-border' 
            style={{
                fontWeight:'normal'
              }}
              label="Delete"
              />
            </Popconfirm>
            </React.Fragment>}
          </div>
        }
    },
    {
        dataIndex: 'id',
        key: 'action',
        width: 40,
        render: (id, record) => {
            return <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
            }}> 
                <Link style={{
                    display: 'flex'
                }} to={{
                    pathname: `/activity/data-type/${datatype}/files`,
                    search: queryString.stringify({
                        file_uri: record.file_uri,
                        fetcher_response_id: record.fetcher_response_id,
                        data_selector_id: record.data_selector_id
                    })
                }}>
                    <InsertDriveFileOutlined
                        titleAccess='Go To Files'
                        className='basic-icon hand-cursor'
                    // onClick={() => {
                    //     console.log("detail clicked")
                    //     typeof onViewclicked === 'function' && onViewclicked(id)
                    // }} 
                    /></Link>
            </div>
        }
    }
]
const MAX_ITERATION=10;
const REFRESHING_INTERVAL=3000;

class SourcePacketList extends Component {
    constructor(props) {
        super(props)

        this.datatype = props.match.params.datatype_id;

        // this.source_id=props.match.params.source_id;

        this.iteration=0;


        this.state = {
            filter_query: {
                per_page: 100,
                page: 1,
                dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
                dateTo: moment().format(defaultDateFormat),
                transferred: 'true',
                // source_id:this.source_id
            },
            loading: true,
            pageLoading:true,
            datatype_obj: {},
            processing_id:null,
            processing_type:null, 
            selected_keys:[]
        }



        this.deleteupto=RESTExecutor.post().config({
            label:'packet_untransfer'
          }).callbacks((success)=>{
            this.setState({processing_id:null,processing_type:null})
            showSuccessInNotification(success,"")

           
            this.startRefreshingPage();

            // message.success("All previous packets untransferred successfully");
            this.list_packets.execute();
            try{
                window.header.refreshNotifiicationCount(10000);
            }catch(e){

            }
          },(error)=>{
            showErrorInNotification(error);
            this.setState({processing_id:null,processing_type:null})
            
          }).connect(props.domains.activity);
      
          this.deletefile=RESTExecutor.post().config({
            label:'packet_delete'
          }).callbacks((success)=>{
            this.setState({processing_id:null,processing_type:null,selected_keys:[]})
            showSuccessInNotification(success,"Selected Packets Deleted")
            this.list_packets.execute();
          },(error)=>{
            showErrorInNotification(error);
            this.setState({processing_id:null,processing_type:null})
          }).connect(props.domains.activity);


          this.classify_packets=RESTExecutor.post().config({
            label:'packet_classify'
          }).callbacks((success)=>{
            this.setState({selected_keys:[]})
            showSuccessInNotification(success,"Selected Packets are being processed.")
          },(error)=>{
            showErrorInNotification(error);
          }).connect(props.domains.activity);

      
          this.retryfile=RESTExecutor.post().config({
            label:'packet_transfer'
          }).callbacks((success)=>{
            this.setState({processing_id:null,processing_type:null,selected_keys:[]})
            this.startRefreshingPage();
            // message.success("File transfer initiated");
            showSuccessInNotification(success,"")
            this.list_packets.execute();
            try{
                window.header.refreshNotifiicationCount();
            }catch(e){

            }
          },(error)=>{
            showErrorInNotification(error);
            this.setState({processing_id:null,processing_type:null})
          }).connect(props.domains.activity);


        this.datatype_detail = RESTExecutor.detail().config({
            label: 'datatypes_details'
        }).callbacks((success) => {
            this.setState({ loading: false, datatype_obj: success.result })
            // overrideHeaderTitle(`${success.result.name} | Files`);
            this.list_packets.forId(this.datatype).config({
                params: {
                    ...this.state.filter_query
                }
            }).execute();
        }, (error) => {
            showErrorInNotification(error);
            this.setState({ loading: false })
        }).forId(this.datatype).connect(props.domains.allData)



        this.list_packets = RESTExecutor.list().config({
            label: 'packet_list'
        }).forId(this.datatype).connect(props.domains.activity);

        this.delay_search = new NetworkDelaySearch();

    }

    startRefreshingPage=()=>{
        this.refreshing=true;
        this.iteration=0;
        this.refreshing_data=setInterval(()=>{
            if(this.iteration<MAX_ITERATION){
            this.list_packets.execute();
            this.iteration++;
            }else{
                this.refreshing=false;
                clearInterval(this.refreshing_data)
            }
        },REFRESHING_INTERVAL)
    }

    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    render() {

        const { filter_query, loading, datatype_obj,selected_keys } = this.state;
        if (loading) {
            return <center><Spin /></center>
        }
        let list_packets_resp = this.list_packets.response();
        let datatype_detail_resp = this.datatype_detail.response();
        let deletefile_resp=this.deletefile.response();
        let classify_packets_resp=this.classify_packets.response();



        let list_packets_data = list_packets_resp.result || {};
        let rowsData = list_packets_data.rows || [];
        let rowsMeta = list_packets_resp.meta || {};

        return (
            <ErrorWrapper
                error={datatype_detail_resp}
                onReload={() => {
                    this.setState({
                        loading: true
                    }, () => {
                        this.datatype_detail.forId(this.datatype).execute()
                    })
                }}
            >
                <div>
                    <BasicHeader
                        title={datatype_obj.name}
                        titleType="Datatype"
                        subtitle={`Packets List For Source: ${filter_query.source_id}`}
                        right={filter_query.transferred=='false'&&[
                            <Popconfirm 
                            disabled={deletefile_resp.fetching||selected_keys.length==0}
                            title={`Are you sure you want to delete ${selected_keys.length} Packets`}
                            onConfirm={()=>{
                                this.deletefile.forId(this.datatype).execute({
                                    packet_ids:selected_keys
                                });
                            }}>
                            <TransparentButton 
                            loading={deletefile_resp.fetching}
                            disabled={selected_keys.length==0||deletefile_resp.fetching}
                            // className='primary-btn'
                            icon={<DeleteOutline/>}
                            label={`Delete`}
                            hint={`Delete ${selected_keys.length} Packets`}
                            /></Popconfirm>,

                            <Popconfirm 
                            disabled={classify_packets_resp.fetching||selected_keys.length==0}
                            title={`Are you sure you want to re-run ${selected_keys.length} Packets`}
                            onConfirm={()=>{
                                this.classify_packets.forId(this.datatype).execute({
                                    packet_ids:selected_keys
                                });
                            }}>
                            <TransparentButton 
                            icon={<ReplayOutlined/>}
                            disabled={selected_keys.length==0}
                            // className='danger-btn'
                            label={`Rerun `}
                            hint={`Rerun ${selected_keys.length} Packets`}
                            />
                            </Popconfirm>
                        ]}
                    />
                    <div style={{
                        width:'90%'
                    }}>
                    <div className='filter-card'>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            flexWrap: 'nowrap',
                            paddingTop: 4, paddingBottom: 12,alignItems:'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center'
                            }}>
                                <span className='heading-1 hand-cursor' 
                                onClick={()=>{
                                    this.stateUpdater({
                                        stateKey: 'filter_query', 
                                        value:'true',
                                        valueKey:'transferred',
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify({...this.state.filter_query,per_page:100,page:1})
                                            })
                                        }
                                    })
                                }}
                                style={{
                                    color: filter_query.transferred=='true' ? COLORS.success_primary : COLORS.secondary
                                }}>Transferred</span>
                                <Divider type='vertical' />
                                <span className='heading-1 hand-cursor' 
                                onClick={()=>{
                                    this.stateUpdater({
                                        stateKey: 'filter_query', 
                                        value:'false',
                                        valueKey:'transferred',
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify({...this.state.filter_query,per_page:100,page:1})
                                            })
                                        }
                                    })
                                }}
                                style={{
                                    color: filter_query.transferred=='true' ? COLORS.secondary : COLORS.danger_primary
                                }}>Not Transferred</span>
                            </div>

                            <CustomDateRangePicker
                                style={{
                                    width: 300,
                                    marginLeft: 16,
                                    flex: null
                                }}
                                startDate={filter_query.dateFrom?moment(filter_query.dateFrom, defaultDateFormat):null}
                                endDate={filter_query.dateTo?moment(filter_query.dateTo, defaultDateFormat):null}
                                onChange={(dates) => {
                                    //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                                    this.stateUpdater({
                                        stateKey: 'filter_query', 
                                        appendObj: {
                                            dateFrom: dates.startDate.format(defaultDateFormat),
                                            dateTo: dates.endDate.format(defaultDateFormat),
                                            per_page: 100, page: 1
                                        },
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify(this.state.filter_query)
                                            })
                                            // this.list_transaction.config({
                                            //     params: {
                                            //         ...this.getParams(),
                                            //         per_page:20,
                                            //         page:1
                                            //     }
                                            // }).execute()
                                        }
                                    })

                                    // this.setState({
                                    //     startDate: dates.startDate,
                                    //     endDate: dates.endDate
                                    // })
                                }}

                            />
                        </div>
                    </div>
                    <ErrorWrapper
                        error={list_packets_resp}
                    >
                        <div className='default-card' style={{
                            // margin:0
                        }}>
                            <Table
                                loading={this.refreshing?false:list_packets_resp.fetching}
                                dataSource={rowsData}
                                className='main-table'
                                size='small'
                                rowKey={(record)=>record.id}
                                rowSelection={filter_query.transferred=='false'?{
                                    onChange:(selected_keys,selected_rows)=>{
                                        this.setState({
                                            selected_keys:selected_keys
                                        })
                                    },
                                    selectedRowKeys:this.state.selected_keys||[]
                                }:null}
                                columns={packets_cols({
                                    processing_id:this.state.processing_id,
                                    processing_type:this.state.processing_type,
                                    datatype:this.datatype,
                                    onDeleteUpto:(id)=>{
                                        this.setState({processing_id:id,processing_type:'delete'});
                                        this.deleteupto.forId(id).execute();
                                      },
                                      onDelete:(id)=>{
                                        this.setState({processing_id:id,processing_type:'delete'});
                                        this.deletefile.forId(this.datatype).execute({
                                            packet_ids:[id]
                                        });
                                      },
                                      onRetry:(id)=>{
                                        this.setState({processing_id:id,processing_type:'retry'});
                                        this.retryfile.forId(id).execute({
                                          transfer:true
                                        });
                                      },
                                })}
                                pagination={{
                                    simple: false,
                                    size: 'small',
                                    position: 'bottom',
                                    onChange: (current, size) => {
                                        this.props.history.push({
                                            search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                        })
                                    },
                                    defaultCurrent: 1,
                                    current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                                    pageSize: (rowsMeta && rowsMeta.requested_count),
                                    total: (rowsMeta && rowsMeta.total_count),
                                    showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                                }}
                            />
                        </div>
                    </ErrorWrapper>
                                </div>
                </div>
            </ErrorWrapper>

        )
    }

    componentDidMount() {

        // this.startRefreshingPage();

        let new_filter_query = {};
        // var source_id = this.props.match.params.source_id;

        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                // dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
                // dateTo: moment().format(defaultDateFormat),
                transferred:'true',
                // source_id:source_id,
                ...new_filter_query
            }
        }, () => {
            this.datatype_detail.execute()
            // this.list_packets.config({
            //     params: {
            //     ...this.state.filter_query
            //     }
            // }).execute()
        })

    }

    componentWillUnmount(){
        clearInterval(this.refreshing_data)
    }
    componentWillReceiveProps(nextProps) {
        var olddatatype_id = this.props.match.params.datatype_id;
        var newdatatype_id = nextProps.match.params.datatype_id;


        // var oldsource_id = this.props.match.params.source_id;
        // var newsource_id = nextProps.match.params.source_id;


        if (olddatatype_id !== newdatatype_id ||
            // (oldsource_id !== newsource_id )|| 
            (this.props.location && (this.props.location.search !== nextProps.location.search))
            ) {
            this.datatype = newdatatype_id;
            // this.source_id=newsource_id;
            const parsed = queryString.parse(nextProps.location.search);
            this.setState({
                selected_keys:[],
                filter_query: {
                    per_page: 100,
                    page: 1,
                    // dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
                    // dateTo: moment().format(defaultDateFormat),
                    // source_id:parsed.source_id,
                    transferred:'true',
                    ...parsed
                },
            }, () => {
                if (olddatatype_id !== newdatatype_id) {
                    this.setState({
                        loading: true
                    }, () => {
                        this.datatype_detail.forId(this.datatype).execute()
                    })
                } else {
                    this.list_packets.forId(this.datatype).config({
                        params: {
                            ...this.state.filter_query
                        }
                    }).execute()
                }



            })

        }
    }


}

export default withDomains(SourcePacketList, "activity", "allData")
